import type { AudienceMatch, AudienceResultsStats } from '@openx/components-core/lib/AiChat/types.ts';
import { useTranslation } from 'react-i18next';
import { MatchResultsCard } from './MatchResultsCard.tsx';

export type AudienceResultsCardProps = {
  matches: AudienceMatch[];
  stats: AudienceResultsStats;
  disabled?: boolean;
};

export const AudienceResultsCard = ({ matches, stats, disabled = false }: AudienceResultsCardProps) => {
  const { t } = useTranslation();

  return (
    <MatchResultsCard
      title={t('Best Audience Matches')}
      metricLabel={t('Reach')}
      disabled={disabled}
      dataTest="audience-results-card"
      matches={matches.map(match => ({ ...match, metric: match.reach }))}
      stats={[
        { label: t('Relevance'), value: stats.relevance },
        { label: t('Viewability'), value: stats.viewability },
        { label: t('CPM'), value: stats.cpm },
        { label: t('Reach'), value: stats.reach },
      ]}
    />
  );
};
